var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 container-content"},[_c('Header'),_c('TableCampaigns')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }